import {StorageName} from "./StorageManager";
import {getManager} from "./Manager";
import {FactoryID} from "../model-factory/type-interface/ModelFactoryType";
import {IAnyObject} from "../common/SimpleInterface";
import {getModelFactory} from "../model-factory/ModelFactory";
import DataFactory from "../model-factory/basic/data/DataFactory";
import {IPopulateIDs} from "../model-factory/type-interface/ModelFactoryInterface";
import DataModel from "../model-factory/basic/data/DataModel";
import {isArray, isNativeObject, isString} from "../common/SiteHelper";

export default class StorageDataManager
{
    storageName: StorageName = "data_model";
    sequenceStorageKey = "storage_sequence";

    previousStorage: IAnyObject | null = null;

    sequence: string[] = [];
    populated: boolean = false;


    clearStorage()
    {
        this.sequence.length = 0;
        getManager().storage.clear(this.storageName).then(_ => {});
    }

    async requirePreviousStorage(): Promise<void>
    {
        if (this.previousStorage !== null)
        {
            return;
        }
        return getManager().storage.getAll(this.storageName).then((allStorage) =>
        {
            this.previousStorage = allStorage;
        })
    }

    async populateFromStorage(addToCurrent:boolean = false): Promise<void>
    {
        if(this.populated){
            return
        }
        await this.requirePreviousStorage();
        const sequence: [] = this.previousStorage![this.sequenceStorageKey] && isArray(this.previousStorage![this.sequenceStorageKey]) ? this.previousStorage![this.sequenceStorageKey] : [];
        if (!sequence)
        {
            return;
        }
        for (let i = 0; i < sequence.length; i++)
        {
            let modelID = sequence[i] as string;
            if (isString(modelID))
            {
                const modelStore = this.previousStorage![modelID] as IAnyObject;
                if (modelStore && isNativeObject(modelStore))
                {
                    const factoryID = modelStore.factory_id as FactoryID;
                    const populateIDs = isNativeObject(modelStore.populate_ids) ? (modelStore.populate_ids as IPopulateIDs) : {};
                    const response = modelStore.response as IAnyObject;
                    if (factoryID && isString(factoryID) && response && isNativeObject(response) && Object.keys(response).length)
                    {
                        const factory = getModelFactory().getFactory(factoryID);
                        if (factory && factory instanceof DataFactory)
                        {
                            const model = factory.requireModel(populateIDs) as DataModel;
                            model.insertRequestResponse(response, true);
                            if(addToCurrent){
                                this.addToStorage(model.id, model.factoryID, model.populateIDs, response, true)
                            }
                        }
                    }
                }
            }
        }
        this.storeSequence();
        this.populated = true;
    }

    addToStorage(modelID: string, factoryID: FactoryID, populateIDs: IPopulateIDs, response: IAnyObject, preventStoreSequence:boolean = false): void
    {
        const currentIndex = this.sequence.indexOf(modelID);
        if (currentIndex !== -1)
        {
            this.sequence.splice(currentIndex, 1);
        }
        this.sequence.push(modelID);
        getManager().storage.set(modelID, {
            factory_id: factoryID,
            populate_ids: populateIDs,
            response: response
        }, this.storageName).then(_ =>
        {
            if(!preventStoreSequence){
                this.storeSequence();
            }
        });
    }

    storeSequence(){
        getManager().storage.set(this.sequenceStorageKey, this.sequence, this.storageName).then(_ => {})
    }
}